import { render, staticRenderFns } from "./a-text.vue?vue&type=template&id=45352ac6&scoped=true&lang=pug"
import script from "./a-text.vue?vue&type=script&lang=js"
export * from "./a-text.vue?vue&type=script&lang=js"
import style0 from "./a-text.vue?vue&type=style&index=0&id=45352ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45352ac6",
  null
  
)

export default component.exports